import React, {Component} from 'react';

export default class WaterView extends Component {
  render() {
    return (
      <section className="container tip-flex">
        <div className="tip-outline">
          <div className="guide-section">
            <h2>Quick Tips</h2>
            <ul>
                <li><p className="tip water-tip">When cooking, peel and clean vegetables in a large bowl of water instead of under running water.</p></li>
                <li><p className="tip water-tip">Add compost or an organic matter to soil as necessary, to improve soil conditions and water retention.</p></li>
                <li><p className="tip water-tip">Repair leaky toilets. Add 12 drops of food coloring into the tank, and if color appears in the bowl one hour later, your toilet is leaking.</p></li>
            </ul>
          </div>
        </div>
        <div className="tip-outline">
          <div className="guide-section">
            <h2>Resources</h2>
            <ul>
              <li className="resource-outline">
                <a href="https://www.epa.gov/greeningepa/water-conservation-epa" target="_blank" rel="noreferrer" >
                  <div className="resource container">
                    <div className="flex-item"><h4>Water Conservation at EPA</h4>
                    <p>The U.S. population has doubled over the past 50 years, while our thirst for water has tripled...</p></div>
                    <div className="flex-item">
                      <img className="resource-image" src='/img/water-site-1.png' alt="epa chart"></img>
                    </div>
                  </div>
                  </a>
              </li>
              <li className="resource-outline">
                <a href="https://www.epa.gov/watersense/start-saving" target="_blank" rel="noreferrer" >
                  <div className="resource container">
                    <div className="flex-item"><h4>Start Saving</h4>
                    <p>Water efficiency is the smart use of our water resources through water-saving technologies and simple steps we can all take around the house...</p></div>
                    <div className="flex-item">
                      <img className="resource-image" src='/img/water-site-3.png' alt="two kids brushing teeth"></img>
                    </div>
                  </div>
                </a>
              </li>
              <li className="resource-outline">
                <a href="https://www.epa.gov/watersense/using-water-efficiently" target="_blank" rel="noreferrer" >
                  <div className="resource container">
                    <div className="flex-item"><h4>Using Water Efficiently</h4>
                    <p>Efficient water use can have major environmental, public health, and economic benefits by...</p></div>
                    <div className="flex-item">
                      <img className="resource-image" src='/img/water-site-2.png' alt="watersense logo"></img>
                    </div>
                  </div>
                  </a>
              </li>
            </ul>
          </div>
          
        </div>
      </section>
    )
  }
}